// Option value sets for the new club administrative/legal fields.
// Stored on the club as plain strings (the schema stays loose), these consts
// drive the admin form dropdowns and any consumer that needs to render labels.

export const ClubEntityType = {
  MembersClub: 'Members Club',
  CompanyLimitedByShares: 'Company limited by shares',
  CompanyLimitedByGuarantee: 'Company limited by guarantee',
  CharitableIncorporatedCompany: 'Charitable Incorporated Company',
  CommunityInterestCompany: 'Community Interest Company (CIC)',
} as const;
export type ClubEntityType = (typeof ClubEntityType)[keyof typeof ClubEntityType];

export const EnglandFootballAccreditation = {
  OneStar: 'One Star',
  TwoStar: 'Two Star',
  ThreeStar: 'Three Star',
  NA: 'N/A',
} as const;
export type EnglandFootballAccreditation =
  (typeof EnglandFootballAccreditation)[keyof typeof EnglandFootballAccreditation];

export const GroundTenureType = {
  Freehold: 'Freehold',
  Leasehold: 'Leasehold',
  Groundshare: 'Groundshare',
} as const;
export type GroundTenureType = (typeof GroundTenureType)[keyof typeof GroundTenureType];

export const PitchType = {
  Grass: 'Grass',
  ThreeG: '3G',
} as const;
export type PitchType = (typeof PitchType)[keyof typeof PitchType];

export const ClubCompetition = {
  FaCup: 'FA Cup',
  FaTrophy: 'FA Trophy',
  AffiliatedCountyCup: 'Affiliated County Cup',
  Other: 'Other competitions',
} as const;
export type ClubCompetition = (typeof ClubCompetition)[keyof typeof ClubCompetition];

export const YesNo = {
  Yes: 'Yes',
  No: 'No',
} as const;
export type YesNo = (typeof YesNo)[keyof typeof YesNo];

export const WeekDay = {
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
} as const;
export type WeekDay = (typeof WeekDay)[keyof typeof WeekDay];

const KICK_OFF_FIRST_HOUR = 17;
const KICK_OFF_LAST_HOUR = 22;
/** Matches the granularity of the league admin's match date-time picker (SC-1131). */
const KICK_OFF_STEP_MINUTES = 5;

const pad = (value: number): string => String(value).padStart(2, '0');

const KICK_OFF_SLOT_COUNT = ((KICK_OFF_LAST_HOUR - KICK_OFF_FIRST_HOUR) * 60) / KICK_OFF_STEP_MINUTES + 1;

/** Selectable midweek kick-off times, every 5 minutes from 17:00 to 22:00 inclusive. */
export const KICK_OFF_TIMES: readonly string[] = Array.from({ length: KICK_OFF_SLOT_COUNT }, (_, index) => {
  const minutesFromMidnight = KICK_OFF_FIRST_HOUR * 60 + index * KICK_OFF_STEP_MINUTES;
  return `${pad(Math.floor(minutesFromMidnight / 60))}:${pad(minutesFromMidnight % 60)}`;
});
